document.addEventListener("click", function (e) {
  var toggleBtn = e.target.closest(".categories-toggle");
  var drawer = document.getElementById("custom-menu-drawer");
  if (!drawer) return;

  if (toggleBtn) {
    drawer.classList.toggle("open");
    toggleBtn.classList.toggle("open");
    return;
  }

  if (drawer.classList.contains("open") && !e.target.closest(".categories-drawer")) {
    drawer.classList.remove("open");
    var btn = document.querySelector(".categories-toggle");
    if (btn) btn.classList.remove("open");
  }
});

document.addEventListener("DOMContentLoaded", function () {

  /* CATEGORY DRAWER - Helper: activate first L2 with L3 children in a submenu */
  function activateFirstL3(inner) {
    /* Clear all L3 active states */
    inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
      sub.classList.remove("category-drawer__l3-submenu--active");
    });
    inner.querySelectorAll(".category-drawer__submenu-link").forEach(function(link) {
      link.classList.remove("category-drawer__submenu-link--l3-active");
    });

    /* Find the active L2 submenu panel */
    var activeSubmenu = inner.querySelector(".category-drawer__submenu--active");
    if (!activeSubmenu) {
      inner.classList.remove("category-drawer__inner--has-l3");
      return;
    }

    /* Find the first L2 link with L3 children */
    var firstL2WithChildren = activeSubmenu.querySelector(".category-drawer__submenu-link[data-l3-target]");
    if (!firstL2WithChildren) {
      inner.classList.remove("category-drawer__inner--has-l3");
      return;
    }

    firstL2WithChildren.classList.add("category-drawer__submenu-link--l3-active");
    var l3TargetId = firstL2WithChildren.getAttribute("data-l3-target");
    var l3Panel = inner.querySelector('.category-drawer__l3-submenu[data-l3-parent="' + l3TargetId + '"]');
    if (l3Panel) {
      l3Panel.classList.add("category-drawer__l3-submenu--active");
      inner.classList.add("category-drawer__inner--has-l3");
    } else {
      inner.classList.remove("category-drawer__inner--has-l3");
    }
  }

  /* CATEGORY DRAWER - L1 hover to show L2 subcategories */
  var drawerCategories = document.querySelector("#custom-menu-drawer .category-drawer__categories");

  if (drawerCategories) {
    drawerCategories.addEventListener("mouseenter", function(e) {
      var category = e.target.closest(".category-drawer__category");
      if (!category) return;

      var inner = drawerCategories.closest(".category-drawer__inner");
      if (!inner) return;

      /* Update active category */
      drawerCategories.querySelectorAll(".category-drawer__category").forEach(function(cat) {
        cat.classList.remove("category-drawer__category--active");
      });
      category.classList.add("category-drawer__category--active");

      var targetId = category.getAttribute("data-target");

      if (targetId) {
        /* Category has children — show L2 panel */
        inner.classList.add("category-drawer__inner--has-l2");

        /* Show matching submenu */
        inner.querySelectorAll(".category-drawer__submenu").forEach(function(sub) {
          if (sub.getAttribute("data-parent") === targetId) {
            sub.classList.add("category-drawer__submenu--active");
          } else {
            sub.classList.remove("category-drawer__submenu--active");
          }
        });

        /* Clear L3 state — L3 only appears on explicit L2 hover */
        inner.classList.remove("category-drawer__inner--has-l3");
        inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__l3-submenu--active");
        });
        inner.querySelectorAll(".category-drawer__submenu-link").forEach(function(link) {
          link.classList.remove("category-drawer__submenu-link--l3-active");
        });
      } else {
        /* Category has no children — hide L2 and L3 panels */
        inner.classList.remove("category-drawer__inner--has-l2");
        inner.classList.remove("category-drawer__inner--has-l3");

        inner.querySelectorAll(".category-drawer__submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__submenu--active");
        });
        inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__l3-submenu--active");
        });
        inner.querySelectorAll(".category-drawer__submenu-link").forEach(function(link) {
          link.classList.remove("category-drawer__submenu-link--l3-active");
        });
      }
    }, true);
  }

  /* CATEGORY DRAWER - L2 hover to show L3 sub-subcategories */
  var drawerSubcategories = document.querySelector("#custom-menu-drawer .category-drawer__subcategories");

  if (drawerSubcategories) {
    drawerSubcategories.addEventListener("mouseenter", function(e) {
      var link = e.target.closest(".category-drawer__submenu-link");
      if (!link) return;

      var inner = drawerSubcategories.closest(".category-drawer__inner");
      if (!inner) return;

      var l3TargetId = link.getAttribute("data-l3-target");

      /* Update active L2 link */
      inner.querySelectorAll(".category-drawer__submenu-link").forEach(function(l) {
        l.classList.remove("category-drawer__submenu-link--l3-active");
      });

      if (l3TargetId) {
        /* L2 has L3 children — show L3 panel */
        link.classList.add("category-drawer__submenu-link--l3-active");
        inner.classList.add("category-drawer__inner--has-l3");

        /* Show matching L3 submenu */
        inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
          if (sub.getAttribute("data-l3-parent") === l3TargetId) {
            sub.classList.add("category-drawer__l3-submenu--active");
          } else {
            sub.classList.remove("category-drawer__l3-submenu--active");
          }
        });
      } else {
        /* L2 has no L3 children — hide L3 panel */
        inner.classList.remove("category-drawer__inner--has-l3");
        inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__l3-submenu--active");
        });
      }
    }, true);
  }

  /* Reset drawer state when it opens — show only L1 column */
  var drawerEl = document.getElementById("custom-menu-drawer");
  if (drawerEl) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName !== "class" || !drawerEl.classList.contains("open")) return;

        var inner = drawerEl.querySelector(".category-drawer__inner");
        if (!inner) return;

        /* Clear all active states */
        drawerEl.querySelectorAll(".category-drawer__category").forEach(function(cat) {
          cat.classList.remove("category-drawer__category--active");
        });
        inner.querySelectorAll(".category-drawer__submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__submenu--active");
        });
        inner.querySelectorAll(".category-drawer__l3-submenu").forEach(function(sub) {
          sub.classList.remove("category-drawer__l3-submenu--active");
        });
        inner.querySelectorAll(".category-drawer__submenu-link").forEach(function(link) {
          link.classList.remove("category-drawer__submenu-link--l3-active");
        });

        /* Remove panel state classes */
        inner.classList.remove("category-drawer__inner--has-l2");
        inner.classList.remove("category-drawer__inner--has-l3");
      });
    }).observe(drawerEl, { attributes: true });
  }

  /* CUSTOM MEGA MENU - L2 hover to show L3 submenus */
  document.querySelectorAll(".custom-mega-menu__categories").forEach(function(panel){

    panel.addEventListener("mouseenter", function(e){
      var category = e.target.closest(".custom-mega-menu__category[data-target]");
      if (!category) return;

      var megaMenu = panel.closest(".custom-mega-menu__inner");
      if (!megaMenu) return;

      var targetId = category.getAttribute("data-target");

      /* Update active category */
      panel.querySelectorAll(".custom-mega-menu__category").forEach(function(cat){
        cat.classList.remove("custom-mega-menu__category--active");
      });
      category.classList.add("custom-mega-menu__category--active");

      /* Show matching submenu */
      megaMenu.querySelectorAll(".custom-mega-menu__submenu").forEach(function(sub){
        if (sub.getAttribute("data-parent") === targetId) {
          sub.classList.add("custom-mega-menu__submenu--active");
        } else {
          sub.classList.remove("custom-mega-menu__submenu--active");
        }
      });
    }, true);

  });

  /* Pre-select first L2 with children when mega menu opens */
  document.querySelectorAll(".custom-mega-menu").forEach(function(menu){
    menu.addEventListener("toggle", function(){
      if (!menu.open) return;

      var firstWithTarget = menu.querySelector(".custom-mega-menu__category[data-target]");
      if (!firstWithTarget) return;

      var megaInner = menu.querySelector(".custom-mega-menu__inner");
      if (!megaInner) return;

      /* Reset active states */
      menu.querySelectorAll(".custom-mega-menu__category").forEach(function(cat){
        cat.classList.remove("custom-mega-menu__category--active");
      });
      firstWithTarget.classList.add("custom-mega-menu__category--active");

      var targetId = firstWithTarget.getAttribute("data-target");
      megaInner.querySelectorAll(".custom-mega-menu__submenu").forEach(function(sub){
        if (sub.getAttribute("data-parent") === targetId) {
          sub.classList.add("custom-mega-menu__submenu--active");
        } else {
          sub.classList.remove("custom-mega-menu__submenu--active");
        }
      });
    });
  });

});